import { AttrDepsHandler } from "../AttrDepsHandler";

/* eslint no-restricted-syntax: "off" */
/* eslint no-param-reassign: "off" */

export const articleHandler: AttrDepsHandler = {
  search: (attr) => {
    const articleInfo = attr.articleNumberInfo;
    if (!articleInfo) return [];
    return [
      ...(articleInfo.groupBy?.attrIds ?? []),
      ...articleInfo.attributes.map((a) => a.attributeId),
    ];
  },
  replace: (attr, meta) => {
    const articleInfo = attr.articleNumberInfo;
    if (!articleInfo) return;
    for (const infoAttr of articleInfo.attributes) {
      const newId = meta.attrSrcToDst[infoAttr.attributeId];
      if (newId) {
        infoAttr.attributeId = newId;
      }
    }
    if (articleInfo.groupBy?.attrIds) {
      articleInfo.groupBy.attrIds = articleInfo.groupBy.attrIds.map(
        (oldId) => meta.attrSrcToDst[oldId] ?? oldId,
      );
    }
  },
};
